import * as React from 'react'
import styles from './index.module.css'

export default class Loading extends React.Component<any> {
  render(): React.ReactElement<'div'> {
    return (
      <div className={styles.loading}>
        <div className={styles.loadingContent}>Loading</div>
      </div>
    )
  }
}
